var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5332 30.6758C23.8175 30.6758 30.5332 23.9601 30.5332 15.6758C30.5332 7.39151 23.8175 0.675781 15.5332 0.675781C7.24893 0.675781 0.533203 7.39151 0.533203 15.6758C0.533203 23.9601 7.24893 30.6758 15.5332 30.6758ZM7.75474 7.89761C8.14526 7.50708 8.77843 7.50708 9.16895 7.89761L15.5329 14.2616L21.8969 7.89761C22.2874 7.50708 22.9206 7.50708 23.3111 7.89761C23.7016 8.28813 23.7016 8.9213 23.3111 9.31182L16.9471 15.6758L23.3111 22.0397C23.7016 22.4303 23.7016 23.0634 23.3111 23.454C22.9206 23.8445 22.2874 23.8445 21.8969 23.454L15.5329 17.09L9.16895 23.454C8.77843 23.8445 8.14526 23.8445 7.75474 23.454C7.36421 23.0634 7.36421 22.4303 7.75474 22.0397L14.1187 15.6758L7.75474 9.31182C7.36421 8.9213 7.36421 8.28813 7.75474 7.89761Z",
    fill: "#A60F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.375fb916e6b8a916f4d29de08a3b20df.svg";
export { ForwardRef as ReactComponent };